<template lang="pug">
Page.bank-edit
    .bank-edit__top(
        slot="header"
    )
        h1.bank-edit__title
            | Создание банка

        SvMenu(
            @copy="copy"
            @remove="remove"
        )

    SvTabs.bank-edit__table(
        :tabs="['Основное']"
        :current="0"
    )
        .bank-edit__actions
            SvButton.bank-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.bank-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.bank-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )

    .bank-edit__form
        .bank-edit__form-item
            span.bank-edit__form-title
                | Активность

            .bank-edit__form-elements--small.radio
                SvRadio.bank-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.bank-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )

        .bank-edit__form-item
            span.bank-edit__form-title
                | Название

            .bank-edit__form-elements--small
                SvInput(
                    v-model="name"
                    color="graylight"
                    placeholder="Например: Сбербанк"
                    :withIcon="false"
                )

        .bank-edit__form-item
            span.bank-edit__form-title
                | Символьный код

            .bank-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    placeholder="Например: Sberbank"
                    color="graylight"
                    :withIcon="false"
                )




        .bank-edit__form-item
            span.bank-edit__form-title
                | Мин. перв. взнос в %

            .bank-edit__form-elements--small
                SvInput(
                    v-model="initial_fee"
                    mask="percent"
                    color="graylight"
                    placeholder="Например: 20"
                    :withIcon="false"
                )

        .bank-edit__form-item
            span.bank-edit__form-title
                | Мин. ставка в %

            .bank-edit__form-elements--small
                SvInput(
                    v-model="mortgage_rate"
                    mask="percent"
                    color="graylight"
                    placeholder="Например: 4,7"
                    :withIcon="false"
                )

        .bank-edit__form-item
            span.bank-edit__form-title
                | Логотип

            .bank-edit__form-elements--small
                SvUpload(
                    v-model="logo"
                )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import { rusToLatin } from '@/helpers/transform';

export default {
  name: 'BankEdit',

  beforeMount() {
    this.$store.dispatch('bank/getById', this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('bank/getById', to.params.id);
    }
    next();
  },

  computed: {
    ...mapGetters({
      current: 'bank/getCurrent',
    }),

    is_active: {
      get() {
        // Обертка Boolean, т.к. с севера приходит 1 или 0
        return Boolean(this.current.is_active);
      },
      set(is_active) {
        this.setValue({ is_active });
      },
    },



    initial_fee: {
      get() {
        return this.current.initial_fee;
      },
      set(initial_fee) {
        // const reg = /^(100|([0-9]{1,2}))([\.\,][0-9]{1,2})?$/;
        // const revReg = /^[a-zа-яё]+$/i;
        // if (!reg.test(min_deposit)) {
        //   value = value.replace(revReg, '');
        // }
        this.setValue({ initial_fee });
      },
    },

    mortgage_rate: {
      get() {
        return this.current.mortgage_rate;
      },
      set(mortgage_rate) {
        this.setValue({ mortgage_rate });
      },
    },



    name: {
      get() {
        return this.current.name;
      },
      set(name) {
        this.setValue({ name });
        this.setValue({ alias: rusToLatin(this.name) });
      },
    },

    alias: {
      get() {
        return this.current.alias;
      },

      set(alias) {
        this.setValue({ alias });
      },
    },

    logo: {
      get() {
        return this.current.logo;
      },

      set(logo) {
        this.setValue({ logo });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'bank/setValue',
    }),

    resetForm() {
      this.$store.commit('bank/clearCurrent');
      this.$router.push({ name: 'banks' });
    },

    copy() {
      this.$store.commit('bank/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({ name: 'bank-edit', params: { id: 'new' } });
    },

    async remove() {
      await this.$store.dispatch('bank/remove', this.$route.params.id);
      this.$router.push({ name: 'banks' });
    },

    async save(isRedirect = false) {
      const id = await this.$store.dispatch('bank/save');
      if (!isRedirect) {
        this.$router.push({
          name: 'bank-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.resetForm();
      }
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvUpload,
  },
};
</script>

<style lang="scss" scoped>
.bank-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.bank-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.bank-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.bank-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bank-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.bank-edit__form {
    padding: 50px 0;
}

.bank-edit__form-radio {
    margin-right: 21px;
}

.bank-edit__form-elements--medium {
    width: 495px;
}

.bank-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.bank-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
